import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import Button from "../components/shared/button";
import ReminderCard from "./../components/cards/reminderCard";
import SetReminderModal from "../modals/setReminderModal";
import { getAllReminders } from "../APIs/remindersApis";

const AllRemindersModal = ({
  allReminderModalOpen,
  setallReminderModalOpen,
}) => {
  const [RemModelOpen, setRemModelOpen] = useState(false);
  const handleOk = () => {
    setallReminderModalOpen(false);
  };


  const [allreminder , setAllReminders]= useState([]) 
  const handleCancel = () => {
    setallReminderModalOpen(false);
  };

  const addRemindersClick = () => {
    setallReminderModalOpen(false);
    setRemModelOpen(true);
  };



  return (
    <>
      <Modal
        open={allReminderModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content  flex flex-col items-center py-[40px] px-[26px] max-sm:px-[20px] gap-[32px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            Reminders
          </h5>
          <div className="reminder-card-wrapper bg-transparent flex flex-col gap-[11px] pr-[22px] max-sm:pr-[8px] max-h-[402px] overflow-y-auto w-full my-auto">
            <ReminderCard
    
              closeAllRemindersModal={() => setallReminderModalOpen(false)}
                        
            />
          </div>
          <Button
            text="Add Reminder"
            className="button btn-blue !rounded-[39px] large mt-[5px] m-auto"
            height={45}
            width={176}
            onClick={addRemindersClick}
          />
        </div>
      </Modal>
      <SetReminderModal
        RemModelOpen={RemModelOpen}
        setRemModelOpen={setRemModelOpen}
        setallReminderModalOpen={setallReminderModalOpen}
      />
    </>
  );
};

export default AllRemindersModal;
